import axios from '../utils/axios';

export default function updateCompanyLogoS3(recId,companyId,data) {
    return (
        axios.post('/admin/' + recId +'/company-management/company/'+companyId+'/uploadLogoOnS3',  data, {headers: {
            'Content-Type': 'image/png'
        } })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}